var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreVert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98855 6.12557C9.74388 6.12557 10.3619 5.50758 10.3619 4.75226C10.3619 3.99693 9.74388 3.37894 8.98855 3.37894C8.23323 3.37894 7.61523 3.99693 7.61523 4.75226C7.61523 5.50758 8.23323 6.12557 8.98855 6.12557ZM8.98855 7.49889C8.23323 7.49889 7.61523 8.11688 7.61523 8.87221C7.61523 9.62754 8.23323 10.2455 8.98855 10.2455C9.74388 10.2455 10.3619 9.62754 10.3619 8.87221C10.3619 8.11688 9.74388 7.49889 8.98855 7.49889ZM8.98855 11.6188C8.23323 11.6188 7.61523 12.2368 7.61523 12.9922C7.61523 13.7475 8.23323 14.3655 8.98855 14.3655C9.74388 14.3655 10.3619 13.7475 10.3619 12.9922C10.3619 12.2368 9.74388 11.6188 8.98855 11.6188Z",
    fill: "#ADADAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4798,
    height: 16.4798,
    fill: "white",
    transform: "translate(0.749023 0.632294)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVert);
export default __webpack_public_path__ + "static/media/more-vert.9a337b9802f924b1fbd2595a0969362d.svg";
export { ForwardRef as ReactComponent };